<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RDTOqQ/tc-custom/9781250032843.jpg?1722314790025" alt="This image is the cover for the book Melissa Explains It All"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Melissa Explains It All
      </h1>
      <p class="bookDescription body article font2">
        <p>Melissa Joan Hart explained it all-from dating to bullies-in her groundbreaking role as Clarissa Darling on <i>Clarissa Explains It All</i>. She cast a spell on millions more viewers as <i>Sabrina, the Teenage Witch</i>. Now, in <i>Melissa Explains It All, </i>Melissa tells the frank and funny behind-the-scenes stories from her extraordinary past and her refreshingly normal present.<br/><br/>Melissa has been entertaining audiences most of her life; when there were no girls named Melissa on her favorite show, the forceful four year old decided she'd get on television her way. From that moment on, Melissa has shown a singular determination and focus-whether it's for booking three national commercials so her dad would build her a tree house or for nailing the audition for <i>Clarissa</i>. <br/><br/>From her first commercial to her current starring role in ABC Family's hit <i>Melissa and</i><i>Joey</i>, Hart never let fame go to her head. She always had one foot in Hollywood and one foot in reality-and still does. Melissa makes us laugh along with her as she talks about:<br/><br/>--guest appearances in shows like <i>Saturday Night Live</i> and <i>The Equalizer</i><br/>--auditioning for <i>Punky Brewster </i>and<i> Clarissa<br/></i>--her early Broadway days<br/>--wacky parties she's thrown and attended<br/>-- the actors who influenced her and whom she befriended, worked with and competed against <br/>--her experiences both on and off-set-with <i>Sabrina</i>'s Salem the Cat and Elvis the Alligator on <i>Clarissa</i><br/>--how she met the love of her life at the Kentucky Derby <br/>Melissa Joan Hart explains all that she's learned along the way-what's kept her grounded, normal and working when others have not been so fortunate-and that she's the approachable, hilarious girl-next-door her fans have always thought she'd be.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Melissa Joan Hart
      </h2>
      
      <p class="authorDescription body article">MELISSA JOAN HART is an actor/producer/director who made her first national commercial at age four. Melissa currently co-stars in the ABC Family comedy series <I>Melissa & Joey</I>. She made her first big splash in the title role of Nickelodeon's <I>Clarissa Explains It All</I>. . Both in the United States and abroad, Melissa is perhaps best known for her starring role in the Showtime movie-turned-network series, <I>Sabrina, the Teenage Witch</I>.  Melissa has appeared on <I>Dancing with the Stars, That 70's Show</I>, and <I>Law and Order: SVU</I>, among others. Her production company, Hartbreak Films, has produced projects including Sabrina, Melissa & Joey, and a number of television movies and feature films.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f0af4d6